export const PlatesSteps = {
  // first flow plates
  intro: 'INTRO_PLATE',
  occupation: 'OCCUPATION_PLATE',
  analysis: 'ANALYSIS_PLATE',
  needs: 'NEEDS_PLATE',
  disabledAnalysis: 'DISABLED_ANALYSIS_PLATE',
  disabledNeeds: 'DISABLED_NEEDS_PLATE',
  process: 'PROCESS_PLATE',

  // second flow plates
  basicInfo: 'BASIC_INFO_PLATE',
  health: 'HEALTH_PLATE',
  disabledHealthFirst: 'DISABLED_HEALTH_FIRST_PLATE',
  disabledHealthSecond: 'DISABLED_HEALTH_SECOND_PLATE',
  generalHealth: 'GENERAL_HEALTH_PLATE',
  company: 'COMPANY_PLATE',
  product: 'PRODUCT_PLATE',
  result: 'RESULT_PLATE',

  //lead data plates
  email: 'EMAIL_PLATE',
  beneficiary: 'BENEFICIARY_PLATE',
  payment: 'PAYMENT_PLATE',
  summary: 'SUMMARY_PLATE',
};

export const ProtectionTypes = {
  family: 'FAMILY_PROTECTION',
  mortgage: 'MORTGAGE_PROTECTION',
  debt: 'DEBT_PROTECTION',
  finalExpenses: 'FINAL_EXPENSES',
};

export const DiseaseTypes = {
  cancer: 'CANCER',
  heartAttack: 'HEART_ATTACK',
  heartDisease: 'HEART_DISEASE',
  stroke: 'STROKE',
  diabetes: 'DIABETES',
  asthma: 'ASTHMA',
  sleepApnea: 'SLEEP_APNEA',
  copd: 'COPD',
  emphysema: 'EMPHYSEMA',
  depression: 'DEPRESSION',
  bloodPressure: 'BLOOD_PRESSURE',
  cholesterol: 'CHOLESTEROL',
  chronicPain: 'CHRONIC_PAIN',
};
